import { Flex, Text } from '@inflearn/ds-react';
import type { RedLightGameHUDProps } from './types';

export const RedLightGameHUD = ({ elapsedTime }: RedLightGameHUDProps) => {
  // 밀리초를 초 단위로 변환 (소수점 둘째자리까지)
  const timeInSeconds = (elapsedTime / 1000).toFixed(2);

  return (
    <Flex
      pos="absolute"
      w={150}
      top={16}
      left={16}
      gap={16}
      align="center"
      css={{
        padding: '6px 16px',
        background: 'rgba(255, 255, 255, 0.6)',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 10,
      }}
    >
      <Text size="lg" fw={700} c="gray.8">
        ⏱️ {timeInSeconds}
      </Text>
    </Flex>
  );
};
